import { Product } from '../../constants/apis';
import type { GetProductPriceType } from '../../types/product/shared';
import { ApiManager } from '../axios-config';

export * from './category';
export * from './detail';

export const getProductPrices = (ids: string[]) => {
  const getProductPricesUrl = new URL(`${Product}/price/multi`);
  const params = new URLSearchParams();

  ids.forEach((id) => params.append('ids', id));
  getProductPricesUrl.search = params.toString();

  return ApiManager.get<GetProductPriceType[]>(getProductPricesUrl.toString(), {
    params: {
      ids,
    },
  });
};
